import axios from '@/http/index';

const base = '';
// 查询会员套餐订单记录
export const selectVipCardOrderList = (param) => axios.get(`${base}/erp/lookVipCard/selectVipCardOrderList`, param).then((res) => res.data);
// 获得项目列表
export const getItemLIst = (param) => axios.get(`${base}/erp/technicianOrder/getItemLIst`, param).then((res) => res.data);
// 获得统称预约时间段
export const postTechnicianOrderList = (param) => axios.post(`${base}/erp/technicianOrder/getTechnicianOrderList`, param).then((res) => res.data);
// 保存预约信息
export const postSaveBookOrder = (param) => axios.post(`${base}/erp/technicianOrder/saveBookOrder`, param).then((res) => res.data);
// 获得项目分类列表
export const getItemTypeLIst = (param) => axios.get(`${base}/erp/technicianOrder/getItemTypeLIst`, param).then((res) => res.data);
// 获取 历史工资
export const getLsgz = (param) => axios.get(`${base}/erp/lookSalarySubsidyDeduct/selectHistorySalaryList`, param).then((res) => res.data);
// 获取 当月工资/上月工资
export const getDygzOrSygz = (param) => axios.get(`${base}/erp/lookSalarySubsidyDeduct/selectSalaryList`, param).then((res) => res.data);
// 获取 扣款/补助/奖金
export const getJjkkbzData = (param) => axios.get(`${base}/erp/lookSalarySubsidyDeduct/selectSubsidyDeductList`, param).then((res) => res.data);
// 添加 扣款/补助/奖金
export const postAddJjkkbzData = (param) => axios.post(`${base}/erp/lookSalarySubsidyDeduct/insertSubsidyDeduct`, param).then((res) => res.data);
// 获取 扣款/补助/奖金
export const getDelJjkkbzData = (param) => axios.get(`${base}/erp/lookSalarySubsidyDeduct/deleteSubsidyDeduct`, param).then((res) => res.data);
// 获得预约表格数据
export const getBespeakTable = (param) => axios.get(`${base}/erp/bookOrder/getBookOrderList4Table`, param).then((res) => res.data);
// 取消预约
export const getBookFailures = (param) => axios.get(`${base}/erp/bookOrder/bookFailures`, param).then((res) => res.data);
// 获得预约列表
export const getBookOrderList = (params) => axios.get(`${base}/erp/bookOrder/getBookOrderList`, params).then((res) => res.data);
// 订单标记已读
export const bookRead = (params) => axios.get(`${base}/erp/bookOrder/bookRead`, params).then((res) => res.data);
// 订单是否存在未读(存在：true,不存在：false)
export const getBookReadStatus = (param) => axios.get(`${base}/erp/bookOrder/getBookReadStatus`, param).then((res) => res.data);
// 3.8.0获得socket的token
export const getSocketToken = (param) => axios.get(`${base}/erp/login/getSocketToken`, param).then((res) => res.data);
// 4.4.0获得预约看板
export const getBookOrders = (param) => axios.get(`${base}/erp/bookOrder/getBookOrders`, param).then((res) => res.data);
// 4.4.0待确认状态  确认和拒绝事件  确认是1或取消是0
export const getSureOrFalse = (param) => axios.get(`${base}/busmanage/booksOrder/getSureOrFalse`, param).then((res) => res.data);

// （5.6）预约订单取消提示
export const getBookCancelMsg = (param) => axios.get(`${base}/erp/bookOrder/getBookCancelMsg`, param).then((res) => res.data);

// （5.6）版本,批量设置统称不可预约时间
export const batchSetNoBookTime = (param) => axios.post(`${base}/erp/bookOrder/batchSetNoBookTime`, param).then((res) => res.data);
// (5.6)查询列表设置功能
export const queryEntryByMainId = (param) => axios.get(`${base}/erp/achivement/queryEntryByMainId`, param).then((res) => res.data);
// (5.6)保存或更新列表设置功能
export const saveOrUpdateEntry = (param) => axios.post(`${base}/erp/achivement/saveOrUpdateEntry `, param).then((res) => res.data);

// 6.3获得token值
export const getToken = (params) => axios.get(`${base}/erp/login/getCookiesMsg`, params).then((res) => res.data);

// 6.6获取预约订单详情
export const getBookOrderDetail = (params) => axios.get(`${base}/erp/bookOrder/getBookOrderDetail`, params).then((res) => res.data);

// (4.1订单详情)获得服务开单订单详情
export const getOrderDetail4AllDto = (param) => axios.get(`${base}/erp/customerOrder/getOrderDetail4AllDto`, param).then((res) => res.data);

// 6.6获取预约订单详情
export const getTechnicianList = (params) => axios.get(`${base}/erp/technicianOrder/getTechnicianList`, params).then((res) => res.data);
